module.exports = __webpack_public_path__ + "static/media/video-image.b6e8410e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-image.png
// module id = 7006
// module chunks = 2